import { IndustryType } from '../codegen/graphql';

/**
 * Appends the backend fallback-image selector to an image URL:
 * d=s (ARGOS) for SEMICONDUCTOR, d=i (OTTO) for INDUSTRY.
 * Unknown industry type leaves the URL untouched, so the backend
 * serves its neutral default icon as fallback.
 */
export const appendImageFallbackParam = (
    url: string,
    industryType?: IndustryType | null,
): string => {
    if (industryType !== IndustryType.SEMICONDUCTOR && industryType !== IndustryType.INDUSTRY) return url;
    const d = industryType === IndustryType.SEMICONDUCTOR ? 's' : 'i';
    return `${url}${url.includes('?') ? '&' : '?'}d=${d}`;
};
